import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { DeletePopupComponent } from "src/app/shared/components/delete-popup/delete-popup.component";
import { IncidentTrackerService } from "src/app/shared/services/incident-tracker.service";
import { ToastrService } from "ngx-toastr";
import { AssessmentPreviewModalDialogComponent } from "src/app/pages/incident-tracker/incident-tracker-templates/incident-tracker-templates.component";
import { IncidentTrackerAssessmentCreateModalDialogComponent } from "src/app/pages/incident-tracker/incident-tracker-templates/incident-tracker-assessment-create-modal/incident-tracker-assessment-create-modal";
import textConfiguration from "src/assets/static-text-configuration.json";
@Component({
  selector: "app-audits-library",
  templateUrl: "./audits-library.component.html",
  styleUrls: ["./audits-library.component.scss"],
})
export class AuditsLibraryComponent implements OnInit {
  @Input() dataLoaded: boolean;
  @Input() filteredTemplate: any[];
  @Input() unCategorizedTemplates: any[];
  @Input() showHeader: any = true;
  @Input() openFrom: any = "GRC-Library";
  @Input() activeTab: any = 0;
  @Output() templateDeleted = new EventEmitter<any>();
  templates: any = [];
  commonText: any = (textConfiguration as any).common;
  isCategoryView = false;

  constructor(
    private readonly dialog: MatDialog,
    private readonly incidentTrackerService: IncidentTrackerService,
    private readonly toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.showHeader === "false") {
      this.showHeader = false;
    }
  }

  toggleView() {
    this.isCategoryView = !this.isCategoryView;
  }

  getGMapRandomColor() {
    const colorNum = 360;
    const color = Math.floor(Math.random() * colorNum);
    return `hsla(${color}, 50%, 25%, 90%)`;
  }

  previewAssessment(template: any, tags: any) {
    const dialog = this.dialog.open(AssessmentPreviewModalDialogComponent, {
      width: "50vw",
      disableClose: true,
      autoFocus: false,

      data: {
        dataKey: template,
        tagsList: tags,
      },
    });
    dialog.afterClosed().subscribe((data) => {
      if (data) {
        this.proceed(template, tags);
      }
    });
  }

  proceed(template: any, tags: any) {
    this.dialog.open(IncidentTrackerAssessmentCreateModalDialogComponent, {
      width: "500px",
      disableClose: true,
      autoFocus: false,

      data: {
        template_id: template.id,
        template_name: template.title,
        openFrom: this.openFrom,
        activeTab: this.activeTab,
      },
    });
  }

  deleteTemplate(id: any, name: string) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      disableClose: true,
      data: name,
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.incidentTrackerService.deletedAuditTemplate(id).subscribe(() => {
          this.toastrService.success("Template deleted successfully");
          this.unCategorizedTemplates = this.unCategorizedTemplates.filter(
            (item: any) => item.id !== id
          );
          this.templateDeleted.emit(this.unCategorizedTemplates.length);
        });
      }
    });
  }
}
